import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Get, Put, Post } from 'utils/axios-token'
import { requestSuccess, requestError } from 'utils/requestHandler'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import Lang from 'Lang/General'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      selectedUpload: null
    }

    onChangeUploadHOC = ( key, value ) => this.setState({ [key]: value })

    load = val => this.setState({loading: val})

    getSelectedUpload = portalUserID => Get(
      `/api/v1/fex/uploads?query=${convertSearchObjectToBase64({"is_paginated":false,"filter":{"user_id":portalUserID}})}`,
      payload => this.setState({ selectedUpload: payload.data?.[0]??null }),
      error => requestError(error),
      this.load
    )

    updateUpload = dataToSubmit => Put(
      `/api/v1/fex/uploads/${dataToSubmit.id}`,
      dataToSubmit,
      () => {
        this.props.onChangePortalUsersHOC('showUploadModal', false )
        this.getSelectedUpload(dataToSubmit.user_id)
        requestSuccess(Lang[ 'RECORD_UPDATED_SUCCESSFULLY' ][ this.props.data.languageReducer.userSettings.admin_panel_language ])
      },
      error => requestError(error),
      this.load
    )

    createUpload = dataToSubmit => Post(
      `/api/v1/fex/uploads`,
      dataToSubmit,
      () => {
        this.props.onChangePortalUsersHOC('showUploadModal', false )
        this.getSelectedUpload(dataToSubmit.user_id)
        requestSuccess(Lang[ 'RECORD_CREATE_SUCCESS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ])
      },
      error => requestError(error),
      this.load
    )

    render = () => {
      return(
        <>
          <WrappedComponent
            { ...this.props }
            { ... this.state }
            onLoadUpload={this.state.loading}

            createUpload={this.createUpload}
            onChangeUploadHOC={ this.onChangeUploadHOC }
            getSelectedUpload={this.getSelectedUpload}
            updateUpload={this.updateUpload} 
            />
        </>
      )
    }

  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps)( WithHOC )
}

export default HOC
